<template>
    <div class="animated fadeIn">
    
     
    
      <b-card no-body>
        <b-card-body>
        <b-row>
          <b-col lg="12">
         <b-button variant="primary" class="pull-left" @click="print" :disabled="products.length <= 0">
          Export To CSV
        </b-button>
        </b-col>
        </b-row>
        <br/>
          <b-row>
          <b-col lg="12">
    
    
        <ag-grid-vue
                 class="ag-theme-balham"
                 id="myGrid"
                 :gridOptions="gridOptions"
                 :columnDefs="columns"
                 :rowData="products">
        </ag-grid-vue>
    
        </b-col>
        </b-row>
    
    
        </b-card-body>
      </b-card>
    
    
    </div>
    
    </template>
    
    <script>
    import { mapState } from 'vuex'
    import Vue from 'vue'
    import {AgGridVue} from "ag-grid-vue";
    
    export default {
      name: 'LowStockReport',
      components: {
        AgGridVue
      },
      props: {
      systemid: {
        type: Number,
        default: null,
      },
     },
      data: function() {
        return {        
          products: [],
          gridOptions : {},
          gridApi: null,
          columns : [],
          useVuex: false,
          theme: 'bootstrap4',
          template: 'default'
        }
      },
      methods: {
    
      search() {
          this.products = []
          let params = {
            systemid: this.systemid,            
          }
          Vue.axios.post('pos/lowstockproducts', params, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(response => {
            this.products = response.data.data.data
            if(this.products.length > 0){
            this.columns = [
                {headerName: 'Product Name', field: 'name', sortable: true, filter: true, minWidth: 150,maxWidth: 300},
                {headerName: 'Category Name', field: 'category.name', sortable: true, filter: true, minWidth: 150,maxWidth: 300},                
                {headerName: 'Current Stock', field: 'stock_in_hand', sortable: true, filter: true, minWidth: 150,maxWidth: 300},
                {headerName: 'Alert Threshold', field: 'low_stock_alert', sortable: true, filter: true, minWidth: 150,maxWidth: 300},

                
                ];
            }
            else{
            this.columns = [];
            }
            this.showSuccessMsg()
          })
          .catch ( error => {
            this.showErrorMsg()
          });
        },
    
    
      print() {
         this.gridApi.exportDataAsCsv({});
      }
      },
      created () {
      },
      mounted() {
        this.gridApi = this.gridOptions.api;
        this.search();
    
      }
    
    }
    
    
    </script>
    